import { createReducer } from 'typesafe-actions';

import {
  ISearchHistoryState,
  TSearchHistoryAction,
  SearchHistoryActionTypes,
} from '@/store/types/search-history.types';

const initialState: ISearchHistoryState = {
  searchHistoric: [],
  isLoading: false,
};

export const searchHistoryReducer = createReducer<ISearchHistoryState, TSearchHistoryAction>(initialState)
  .handleType(SearchHistoryActionTypes.ADD_SEARCH_HISTORY, (state, action) => {
    let searchedKey: string;
    if (action.searchHistory.filters && state.searchHistoric) {
      searchedKey =
        Object.keys(action.searchHistory.filters).find(
          (filterKey) => action.searchHistory.filters?.[filterKey] !== '',
        ) ?? '';
    }
    return {
      ...state,
      searchHistoric: [
        ...state.searchHistoric.filter(
          (history) => history.filters?.[searchedKey] !== action.searchHistory.filters?.[searchedKey],
        ),
        action.searchHistory,
      ],
    };
  })

  .handleType(SearchHistoryActionTypes.REMOVE_SEARCH_HISTORY, (state, action) => {
    const searchHistories = [...state.searchHistoric];
    const indexToRemove = action.indexToRemove;

    if (searchHistories.length >= indexToRemove && searchHistories[indexToRemove])
      searchHistories.splice(indexToRemove, 1);

    return {
      ...state,
      searchHistoric: searchHistories,
    };
  })

  .handleType(SearchHistoryActionTypes.CLEAR_SEARCH_HISTORY, (state) => {
    return {
      ...state,
      searchHistoric: [],
    };
  });
